'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENTS = exports.EVENTS = {
  UPDATE_MESSAGE: 'Update Message',
  UPDATE_SETTINGS: 'Update Settings',
  VIEW_WIZARD_STEP: 'View Wizard Step',
  CHANGE_WINDOW_LOCATION: 'Change Window Location',
  ABANDON_ONBOARDING: 'Abandon Onboarding',
  WIDGET_INTERACTION: 'Widget Interaction',
  PAGE_VIEW: 'pageview',
  CHAT_INTERACTION: 'Chat Interaction',
  TOGGLE_REP_STATUS: 'toggle-rep-status',
  INDEX_INTERACTION: 'Index Page Interaction',
  ONBOARDING_INTERACTION: 'Onboarding Interaction',
  SETTINGS_INTERACTION: 'Settings Interaction'
};

var EVENT_ACTION_NAMES = exports.EVENT_ACTION_NAMES = {
  CREATE_MESSAGE: 'create',
  UPDATE_EXISTING_MESSAGE: 'update',
  SET_MESSAGE_PROPERTY: 'set message property',
  SET_MESSAGE_TARGET_AUDIENCE: 'set message target audience',
  TOGGLE_MESSAGE_STATUS: 'toggle message status',
  SEND_EMBED_CODE: 'send embed code',
  SET_NOTIFICATION: 'set notification',
  SET_PORTAL_SETTINGS: 'set portal setting',
  SET_USER_SETTING: 'set user setting',
  CLICK_MEETINGS_LINK: 'click meetings link',
  CLICK_USER_DESCRIPTION: 'click user description',
  SEND_VISITOR_EMAIL_ADDRESS: 'submit offline email',
  CLOSE_CONVERSATION: 'close conversation',
  SET_REP_STATUS: 'set rep status',
  NAVIGATE: 'navigate from conversation',
  CLICK_CONTACT: 'click contact',
  INITIALIZE_CONVERSATION: 'conversation started',
  SEND_MESSAGE: 'send message',
  TOGGLE_WIDGET: 'toggle widget',
  CLICK_PROFILE_TIP: 'click profile tip',
  DISMISS_PROFILE_TIP: 'dismiss profile tip',
  SET_LAUNCHERTYPE: 'set launcher type',
  SELECT_EMBED_CODE_OPTION: 'select embed code option',
  CREATE_CONTACT_FOR_CHANNEL: 'associate contact with channel',
  WIDGET_LOADED: 'widget loaded',
  LEFT_ONBOARDING: 'left onboarding',
  SELECT_PERMISSION_VALUE: 'select permission value',
  CLICK_BANNER_ACTION: 'click banner action',
  CLICK_NOTIFICATION_PERMISSION_HELP_LINK: 'click notification permission help link',
  CLICK_VIRAL_LINK: 'click viral link'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/hublytics/TrackingConstants.js
// module id = 480
// module chunks = 0